module.exports = __webpack_public_path__ + "media/proksee-viewer/images/cb-reset-circular-c3a89a49bdc4d8380d53fbe2db45d35e.png";